import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { Header } from '../../../components/contenedor-elementos/interfaces/header.interface';
import { table } from '../../../shared/GenerateTabla/plantillas/models.model';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { ServiciosRiegosService } from '../../../services/riesgo-liquidez/servicios-riegos.service';
import { TranslateService } from '@ngx-translate/core';
import { TableroService } from '../../../shared/GenerateTabla/services/tablero.service';
import { TemplateLoaderService } from '../../../shared/GenerateTabla/plantillas/template-loader.service';
import { CommonVariables } from '../../funciones/funcionesGenerales';
import { messages } from '../../funciones/mensajes';
import { Aligment, ExcelService, FormatText, TypeRow } from '../../../services/excel/excel.service';

@Component({
  selector: 'app-volatilidad',
  templateUrl: './volatilidad.component.html',
  styleUrl: './volatilidad.component.css'
})
export class VolatilidadComponent {
  /**
   * Variables de filtros
  */
  Filters = FiltersM; 
  /**
   * Variables de filtros
   */
  periodos = [];
  cadenaEvaluacion = [];
  private numEvaluaciones = 1;
  /** 
   * Configuración titulo
   */
  header: Header = {
    title: ''
  }
  /**
   * Variables de las tablas
   */
  volatilidad233: table;
  volatilidad4: table;
  verTabla;
  /**
   * Variables de intitución y plantillas
   */
  idInst;
  idAdmin;
  private idPlantilla = 7;
    
  constructor(
    readonly dataService: DataService,
    private service: ServiciosRiegosService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private tableroService: TableroService,
    private readonly templateLoader: TemplateLoaderService,

    private readonly excelService: ExcelService,
  ){
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoLiquidez.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoLiquidez.find(c => c.id === this.idInst);
    this.idPlantilla = instAT.idPlantilla;
    this.getEvaluaciones();
  }

  private async getEvaluaciones(){
    const data = await this.service.getEvaluaciones(this.idPlantilla);
    const info = CommonVariables.obtenerPeriodos([].concat(data.evaluaciones), this.numEvaluaciones);

    this.header.title = await this.translate.instant('liquidez.volatilidad.name');
    this.periodos = info.periodos;

    this.getCadenaEvaluacion();
  }

  private getCadenaEvaluacion(){    
    this.cadenaEvaluacion = this.periodos.flatMap(y => {
      return y.series
      .filter(m => m.check)
      .map(m => {
        return {
          text: m.periodo,
          id: m.id
        }
      })
    });
    this.header.subtitles = this.cadenaEvaluacion;
    this.header = {...this.header};
    this.getData();
  }

  async getData(){
    const configuracion = this.templateLoader.obtenerConfiguracionVolatilidad(this.idAdmin);
    if(configuracion.filas){
      configuracion.id = this.idAdmin;
      var tabla = await this.tableroService.getTabla(
        configuracion,
        this.cadenaEvaluacion,
        this.idPlantilla,
        2.33
      );
      
      const el = tabla.filas.find(e => {
        return e.descripcion.includes('_')
      });
      
      el.descripcion = el.descripcion.replace('_','2.33')
      this.volatilidad233 = tabla;

      var tabla2 = await this.tableroService.getTabla(
        configuracion,
        this.cadenaEvaluacion,
        this.idPlantilla,
        4
      );

      const el2 = tabla2.filas.find(e2 => {
        return e2.descripcion.includes('_')
      });
      
      el2.descripcion = el2.descripcion.replace('_','4')
      
      this.volatilidad4 = tabla2;
      this.verTabla= true;
    }else{
      messages.infoMessageGraph(configuracion);
    }
  }

  showAndHide(fila, tabla){
    const filas = tabla.filas;
    const filter = filas.filter(f => fila.sumar.includes(f.id));
    
    filter.forEach(f =>{
      f.visible = !f.visible;
    });
    
    fila.expandido = !fila.expandido;
  }

  cambioPeriodo(per){
    for(const an of this.periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.periodos = [...this.periodos];
    this.getCadenaEvaluacion();
  }

  exportExcel(){
    messages.messageSaving(this.translate.instant('swal.generando'), this.translate.instant('swal.espere'))
    var titulos = [], alineacion = [], formato = [], data = [], tipo = [];
    var tituloHoja = '', nombreArch = '';

      alineacion = [
        Aligment.LEFT,
        ...this.volatilidad233.filas[0].bandas.map(f => {return Aligment.RIGHT}),
        Aligment.RIGHT,
      ];
      formato = [
        FormatText.TEXT,
        ...this.volatilidad233.filas[0].bandas.map(f => {return FormatText.NUMBERDEC}),
        FormatText.NUMBERDEC,
      ];
      this.volatilidad233.columnas.forEach(h =>{
        titulos.push(h)
      });
      this.volatilidad233.filas.forEach( f => { 
        const aux = [];
        const auxT = [];
        
        auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
        aux.push(f.descripcion);

        if(f.bandasValue){
          f.bandasValue.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push(v ?? '');
          });
        }else {
          f.bandas.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push('');
          });
        }

        tipo.push(auxT);
        data.push(aux);
      });

      data.push([
        '',
        ...this.volatilidad233.filas[0].bandas.map(e => null),
      ]);
      tipo.push([
        '',
        ...this.volatilidad233.filas[0].bandas.map(e => TypeRow.NORMAL),
      ]);

      this.volatilidad4.filas.forEach( f => { 
        const aux = [];
        const auxT = [];
        
        auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
        aux.push(f.descripcion);

        if(f.bandasValue){
          f.bandasValue.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push(v ?? '');
          });
        }else {
          f.bandas.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push('');
          });
        }
        
        tipo.push(auxT);
        data.push(aux);
      });
    tituloHoja = 'VOLATILIDAD';
    nombreArch = 'volatilidad';

    this.excelService.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato, tipo);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }
}
